
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Product } from '../../../models/product.model';
import { AlertService } from '../../../services/alert.service';
import { Group } from '../../../models/group.model';


@Component({
    selector: 'create-edit-product-modal',
    template: require('./create-edit-product-modal.component.html'),
    styles: [require('./create-edit-product-modal.component.css')]
})
export class CreateEditProductModalComponent {
    products: Product[];
    currentProduct: Product;
    isCreatNew: boolean;
    groups: Group[];
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditProductModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.currentProduct = data.currentProduct;
        this.groups = data.groups;
        this.isCreatNew = (data.currentProduct.productId == undefined);
    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateProduct(this.currentProduct).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Product successfully");
                }
            });
        } else {
            this.apiService.createProduct(this.currentProduct).subscribe(r => {
                if (r) {
                    this.dialogRef.close(r);
                    this.alertService.showMessage("Create Product successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/products/create-edit-product-modal/create-edit-product-modal.component.ts